import { extendTheme } from '@chakra-ui/react';

import { components } from './components';
import { foundations } from './foundations';

// Start building a theme as an extension of the Chakra default theme
const extendedTheme = extendTheme({});

// Fully overwrite things that can't be extended
export const theme = {
  // Start from the extension of Chakra's default theme
  ...extendedTheme,

  // Fully overwrite all typography, spacing, color, etc... with our own
  ...foundations,

  // Fully overwrite all components since many of the foundations they rely upon are now deleted
  components,

  // Only control fontFamily as a global style
  styles: {
    ...extendedTheme.styles,
    global: () => ({
      fontFamily: 'default',
    }),
  },
};
